import React from 'react'
import { Promo } from '../sections/Promo'
import { Categories } from '../sections/Categories'
import { MoreSale } from '../sections/MoreSale'
import { Gift } from '../sections/Gift'
import { Offers } from '../sections/Offers'
import { ProductsForYou } from '../sections/ProductsForYou'
import { OtherCategories } from '../sections/OtherCategories'
import { Benefits } from '../sections/Benefits'
import { Slider } from '../layout/Slider'
import { ProductsForYouSm } from '../sections/ProductsForYouSm'
import { CategoriesSm } from '../sections/CategoriesSm'
import { GiftSm } from '../sections/GiftsSm'
import { Counter } from '../sections/Counter'
import { SliderSuscribete } from '../sections/SliderSuscribete'

export const Principal = () => {
  return (
    <>
      <Slider />
      <Promo />

      <div className='categoriesxshide'>
        <Categories className='' />
      </div>

      <div className='categoriesmhide'>
        <CategoriesSm className='' />
      </div>

      <MoreSale />

      <div className='giftsxhide'>
        <Gift />
      </div>

      <div className='giftsmhide'>
        <GiftSm />
      </div>
{/* 
      <CounterXs /> */}
      <Counter />
      
      <Offers showButton={false}/>

      <div className='pforyouxshide'>
        <ProductsForYou className='' />
      </div>

      <div className='pforyousmhide'>
        <ProductsForYouSm className='' />
      </div>

      <OtherCategories />
      <Benefits />
      <SliderSuscribete />

    </>
  )
}
